import React, { useEffect, useMemo, useState } from "react";
import { PlusIcon } from "../../assets/Icons";
import SearchBox from "../../components/common/SearchBox";
import DirectoryList from "../../components/Tables/DirectoryList";
import AddDirectory from "../../Modals/AddDirectory";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { GET_DIRECTORY_LIST, CREATE_DIRECTORY } from "../../apiClient/apiEndpoints";

const Directory = () => {
  const [search, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [directories, setDirectories] = useState([]);
  const [details, setDetails] = useState({ name: "", type: "", channelId: "" });
  const [loading, setLoading] = useState(true);

  const getDirectoryList = async () => {
    try {
      setLoading(true);
      const details = await apiClient.get(`${SSO_URL}${GET_DIRECTORY_LIST}`);
      setDirectories(details);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const saveNewDirectory = async () => {
    try {
      await apiClient.post(`${SSO_URL}${CREATE_DIRECTORY}`, details);
      getDirectoryList();
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setDetails({ name: "", type: "", channelId: "" });
  };

  const filteredDirectories = useMemo(() => {
    if (!search) return directories;
    return directories.filter((e) => e.name?.toLowerCase().includes(search.toLowerCase()));
  }, [search, directories]);

  useEffect(() => {
    getDirectoryList();
  }, []);

  return (
    <>
      <div className="main-list">
        <div className="page-title">
          <h5>Directories</h5>
        </div>
        <section className="px-4">
          <div className="tags-sort my-3">
            <SearchBox search={search} setSearch={setSearch} />

            <button className="DefaultRedBtn" onClick={() => setOpenModal(true)}>
              <PlusIcon />
              Create Directory
            </button>
          </div>

          <DirectoryList list={filteredDirectories} loading={loading} />
        </section>
      </div>

      <AddDirectory
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        setDetails={setDetails}
        details={details}
        saveNewDirectory={saveNewDirectory}
        editMode={false}
      />
    </>
  );
};

export default Directory;
